<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="mb-0">Test Logout</h4>
        </div>
        <div class="card-body">
          <!-- Loading State -->
          <div *ngIf="isLoggingOut" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Logging out...</span>
            </div>
            <p class="mt-3">Clearing authentication tokens...</p>
          </div>

          <!-- Logout Complete -->
          <div *ngIf="logoutComplete && !isLoggingOut">
            <div class="alert alert-success" role="alert">
              <h5 class="alert-heading">Logout Complete!</h5>
              <p>{{ logoutMessage }}</p>

              <hr>

              <div class="bg-light p-2 rounded mb-3">
                <h6>Cleared Session Info:</h6>
                <p class="mb-0">{{ cookieInfoBeforeLogout }}</p>
              </div>

              <div class="mt-3">
                <p class="mb-2"><strong>What was cleared:</strong></p>
                <ul class="mb-3">
                  <li>Authentication cookie from localStorage</li>
                  <li>TrpcService session token</li>
                  <li>All cached user session data</li>
                </ul>
              </div>

              <hr>

              <div class="d-grid gap-2">
                <button type="button" class="btn btn-primary" (click)="navigateToLogin()">
                  <i class="pi pi-sign-in me-2"></i>
                  Go to Test Login
                </button>
                <button type="button" class="btn btn-secondary" (click)="navigateToDashboard()">
                  <i class="pi pi-home me-2"></i>
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-muted text-center">
          <small>This is a test logout component for development</small>
        </div>
      </div>
    </div>
  </div>
</div>
